import React from 'react';
import { Icon } from './Icon.js';
export const IconChatBubbleHome = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M18 9V11V10.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M22 11V6.36842L18 3L14 6.36842V11H22Z", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M10.9639 5H3V21H4.41602L6.37891 17.5098L6.66504 17H21V14H23V19H7.83398L5.87109 22.4902L5.58496 23H1V3H13.3389L10.9639 5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconChatBubbleHome.js.map